const getBonusLabel = (value, options) => options.find(({ value: tempValue }) => tempValue === value)?.label;

export { getBonusLabel };
